import { lazy } from "react";
import ReactDOM from "react-dom/client";
// import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./scripts/eventTrackerScript";
// import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { store } from "./Redux/index";
import "./index.scss";
// import AppRoutes from "./routes/routes";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import HomeLayout from "./layout/HomeLayout";
import packageJson from "../package.json";
import ErrorBoundary from "./components/ErrorBoundary";
import { setSessionId } from "./utils/commonUtils";

const ReduxProviderApp = lazy(() => import("./ReduxProviderApp"));

async function initSentry() {
  const Sentry = await import("@sentry/react");

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_CDN_URL,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost"],
    // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
// call only when you want to start tracking

if (process.env.REACT_APP_SENTRY_ENABLE === "true") {
  initSentry();
}

setSessionId();

// serviceWorkerRegistration.register();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
console.log(`%cAirtel - Applite Team(v${packageJson.version}) ⓒ ${(new Date).getFullYear()}`, "color: #e40000; font-size: 18px; font-weight: bold")

root.render(
  <ErrorBoundary>
    <BrowserRouter basename="/">
      {/* <Provider store={store}>
        <HomeLayout>
          <ToastContainer theme="dark" />
          <AppRoutes />
        </HomeLayout>
      </Provider> */}
      <ReduxProviderApp />
    </BrowserRouter>
  </ErrorBoundary>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

serviceWorkerRegistration.register();